'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _reactRouter = require('react-router');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _constants = require('../../../constants');

var _utils = require('../../../utils');

var _NewCaseModalForm = require('./NewCaseModalForm');

var _NewCaseModalForm2 = _interopRequireDefault(_NewCaseModalForm);

var _NewCaseModalSearch = require('./NewCaseModalSearch');

var _NewCaseModalSearch2 = _interopRequireDefault(_NewCaseModalSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CASE_MAIN_TABS = _constants.AppConstants.CASE_MAIN_TABS,
    splitName = _utils.FormattingUtils.splitName;
var NewCaseModal = (_dec = (0, _mobxReact.inject)('UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(NewCaseModal, _Component);

  function NewCaseModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NewCaseModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewCaseModal.__proto__ || Object.getPrototypeOf(NewCaseModal)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'firstName', _descriptor, _this), _initDefineProp(_this, 'lastName', _descriptor2, _this), _initDefineProp(_this, 'newCase', _descriptor3, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NewCaseModal, [{
    key: 'addNew',
    value: function addNew(fieldConfig, search) {
      this.newCase = true;

      var _splitName = splitName(search);

      var _splitName2 = _slicedToArray(_splitName, 2);

      this.firstName = _splitName2[0];
      this.lastName = _splitName2[1];
    }
  }, {
    key: 'redirectToCase',
    value: function redirectToCase(_case) {
      var caseTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CASE_MAIN_TABS.DETAILS;
      var UiStore = this.props.UiStore;


      UiStore.modals.NewCase.close();
      _reactRouter.browserHistory.push({ pathname: '/case/' + _case.id + '/' + caseTab + '/feed' });
    }
  }, {
    key: 'render',
    value: function render() {
      var onClose = this.props.UiStore.modals.NewCase.close;

      return _react2.default.createElement(
        _Modal2.default,
        { className: 'modal-new-case', show: true, onHide: onClose },
        _react2.default.createElement(
          _Modal2.default.Header,
          { closeButton: true },
          _react2.default.createElement(
            _Modal2.default.Title,
            null,
            'New Case'
          )
        ),
        this.newCase ? _react2.default.createElement(_NewCaseModalForm2.default, {
          firstName: this.firstName,
          lastName: this.lastName,
          redirectToCase: this.redirectToCase
        }) : _react2.default.createElement(_NewCaseModalSearch2.default, {
          addNew: this.addNew,
          redirectToCase: this.redirectToCase
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return NewCaseModal;
}(_react.Component), _class3.propTypes = {
  UiStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'firstName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'lastName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'newCase', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = NewCaseModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CASE_MAIN_TABS, 'CASE_MAIN_TABS', '/app/src/components/layout/modal-new-case/NewCaseModal.js');
  reactHotLoader.register(splitName, 'splitName', '/app/src/components/layout/modal-new-case/NewCaseModal.js');
  reactHotLoader.register(NewCaseModal, 'NewCaseModal', '/app/src/components/layout/modal-new-case/NewCaseModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/layout/modal-new-case/NewCaseModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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